// node modules
import { CSSProperties } from 'react';
// constants
import { THEME_COLORS } from 'modules/ReleaseNotes/constants';

export const releaseNoteCard: CSSFunction<{
  isDarkTheme: boolean;
}> = ({ cssProps }) => {
  const { isDarkTheme } = cssProps;

  return {
    padding: 12,
    gap: 20,
    fontFamily: 'inherit',

    '&:hover': {
      '& .releaseNoteCardTitle': {
        color: isDarkTheme
          ? THEME_COLORS.DARK.linkHover
          : THEME_COLORS.LIGHT.linkHover,
      },
    },
  };
};

export const date: CSSFunction = ({ cssProps }) => {
  const { isDarkTheme } = cssProps;

  return {
    color: isDarkTheme
      ? THEME_COLORS.DARK.textSecondary
      : THEME_COLORS.LIGHT.textSecondary,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '18px',
  };
};

export const title: CSSFunction = ({ cssProps }) => {
  const { isDarkTheme } = cssProps;

  return {
    fontWeight: 600,
    color: isDarkTheme
      ? THEME_COLORS.DARK.textPrimary
      : THEME_COLORS.LIGHT.textPrimary,
    fontSize: 20,
    lineHeight: '24px',
  };
};

export const description: CSSFunction = ({ cssProps }) => {
  const { isDarkTheme } = cssProps;

  return {
    color: isDarkTheme
      ? THEME_COLORS.DARK.textBody
      : THEME_COLORS.LIGHT.textBody,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: '22px',
  };
};

export const imageStyle: CSSProperties = {
  display: 'flex',
  maxWidth: '100%',
  height: 'auto',
  objectFit: 'contain',
};
